export const MUI_X_LICENSE_KEY =
  'e647b42cb797a6981ef4a91f8d264741Tz0xMTc4ODIsRT0xNzg3MzU2NzQwMDAwLFM9cHJlbWl1bSxMTT1hbm51YWwsUFY9UTEtMjAyNixRPTEwLEFUPW11bHRpLEtWPTI=';
